import { Component, ViewEncapsulation } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'lock-status-cell',
  templateUrl: './lock-status-renderer.component.html',
  styleUrls: ['./lock-status-renderer.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class LockStatusRendererComponent implements ICellRendererAngularComp {
  isLocked: boolean = false;
  params: ICellRendererParams;
  hasData: boolean = false;

  constructor() {}

  initilize(params: ICellRendererParams) {
    if (params && params.data) {
      this.hasData = true;
      this.params = params;
      // Get value from params.value (cell value) or params.data[field]
      const value = params.value !== undefined ? params.value : 
                    params.data[params.colDef?.field];
      // Handle boolean, number (1/0), or string ('true'/'false')
      this.isLocked = value === true || value === 1 || value === '1' || value === 'true';
    } else {
      this.hasData = false;
    }
  }

  // called on init
  agInit(params: any): void {
    this.initilize(params);
  }

  // called when the cell is refreshed
  refresh(params: any): boolean {
    this.initilize(params);
    return true;
  }

  // Handle click on the lock icon
  onLockIconClick() {
    if (this.params && this.params.eGridCell) {
      this.params.eGridCell.click();
    }
  }
}
